<template>
  <!-- 词云图 -->
  <div :ref="refId" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

// refId 图表id // datas 图表数据源 // colorList 颜色值

<script>
import baiduAndCloudStyle from '../../../public/baiduAndCloudStyle';

export default {
  props: ['refId', 'datas', 'colorList'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(this.refId, newValue, this.colorList);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas.length > 0) {
      this.setPieOption(this.refId, this.datas, this.colorList);
    }
  },
  methods: {
    setPieOption(refId, datas, colorList) {
      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      const maskResource = new Image();
      maskResource.src = baiduAndCloudStyle.picture();
      this.pieOption = {
        title: {
          text: '',
        },
        backgroundColor: 'rgba(0,0,0,0)',
        tooltip: {
          trigger: 'item',
          confine: true, // 浮窗限制在图表内
          backgroundColor: 'rgba(64, 80, 118, 0.8)', // 通过设置rgba调节背景颜色与透明度
          borderColor: 'rgba(64, 80, 118, 0.8)',
          color: '#fff',
          textStyle: {
            color: '#fff',
          },
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          formatter: (name) => {
            let src = `${name.marker} ${name.data.name} &nbsp;&nbsp;${name.data.value}<br/>`;
            if (!name.data.name) {
              return;
            }
            if (name.data.sun) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < name.data.sun.length; i++) {
                // eslint-disable-next-line no-unused-expressions
                name.data.sun[i];
                src += `${name.marker} ${name.data.sun[i].name} &nbsp;&nbsp;${name.data.sun[i].value}<br/>`;
              }
            }
            // eslint-disable-next-line consistent-return
            return src;
          },
        },

        series: [
          {
            type: 'wordCloud',
            rotationStep: 45,
            maskImage: maskResource,
            gridSize: 8, // 用来调整词之间的距离
            sizeRange: [15, 35], // 用来调整字的大小范围
            // rotationRange: [0, 0], //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内
            rotationRange: [-45, 0, 45, 90],
            // rotationRange: [ 0,90],
            // drawOutOfBound: true, // 超出画布的词汇是否隐藏
            shape: 'pentagon',
            width: '100%',
            height: '100%',
            textStyle: {
              color(e) {
                return (
                  `rgb(${[
                    colorList[e.dataIndex][0],
                    colorList[e.dataIndex][1],
                    colorList[e.dataIndex][2],
                  ].join(',')
                  })`
                );
              },
              // color: function () {
              //   return 'rgb(' +
              //     Math.round(Math.random() * 255) +
              //     ', ' + Math.round(Math.random() * 255) +
              //     ', ' + Math.round(Math.random() * 255) + ')'
              // },
              emphasis: {
                fontSize: 100,
              },
            },
            emphasis: {
              focus: 'self',

              textStyle: {
                shadowBlur: 10,
                shadowColor: '#333',
              },
            },
            // 位置相关设置
            left: 'center',
            top: 'center',
            right: null,
            bottom: null,
            // eslint-disable-next-line no-dupe-keys
            width: '95%',
            // eslint-disable-next-line no-dupe-keys
            height: '95%',
            // 数据
            data: datas,
          },
        ],
      };
      // 渲染图表
      // this.pieEcharts.setOption(this.pieOption);
      this.$nextTick(() => {
        this.pieEcharts.setOption(this.pieOption);
      });
      this.pieEcharts.resize();
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped></style>
